<template>
    <div id="print" class="question_main" v-if="listCourseQuestion != null" :style="{'background-color': backgroundColor }">
        <div class="back_nav" @click="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
        <audio class="audio" :src="errorAudio" id="error_audio"/>
        <audio class="audio" :src="successAudio" id="success_audio"/>
        <div class="left_content">
            <div class="page_num">
                <span>{{questionIndex}}</span>/{{listCourseQuestion.length}}
            </div>
            <div class="question_img_content">
                <audio :src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" autoplay="autoplay"
                       controls=""/>
                <div class="audio_play" @click="playAudio()">
                    <img src="@/Images/question_play.png" alt="" />
                </div>
                <div class="audio_content" v-html="getItemWord()" @click="playAudio()">
                </div>
            </div>
        </div>

        <div class="structure_content">
            <div class="option_content">
                <div class="option_img">
                    <div class="option_img_scroll">
                        <div :id="'option_result_' + index" class="option_img_item" v-for="(item,index) in getOptionArray()" :key="index" @click="optionClick(item, index)" :style="{height:getOptionHeight()}">
                            <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" />
                            <div :id="'error_' + index" class="error"><img src="@/assets/error.png"/></div>
                            <div :id="'success_' + index" class="success"><img src="@/assets/success.png"/></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextClick">
                            <span>{{pageType === 1 ? '本课歌词' : 'Replay'}}</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import '@/assets/animate.min.css'
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                pageType: 0,
                questionIndex:1,
                listCourseQuestion: [],
                showRightAnswerArray:[],
                noShowGuideWordsAfter:1,
                innerPageArticleId:0,
                errorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                successAudio: "https://img.xiaohuasheng.cn/success.mp3",
                optionImgScrollBG: "",
                showEnglishText: true,
                audioUrl: "",
                screenWidth: document.body.clientWidth,
                backgroundColor: '#275ba9',
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                showTransition: false,
            }
        },
        methods:{
            gameQuitClick() {
                this.showTransition = false;
                this.$router.go(-1);
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            getEnglishProgramStar() {
                let that = this;

                if (that.pageType === 0) {
                    that.setFinishPart();
                    return;
                }

                that.showTransition = true;

                setTimeout(() => {
                    const greatAudio = document.getElementById('great_audio');
                    greatAudio.play();
                }, 200);

                // type 7-复习
                Utils.$emit('setStarCount','7');
            },
            setFinishPart:function () {
                // type 9每周复习
                let that = this;
                let url = "englishProgram/setFinishPart3/" + that.lessonId + "/9";

                that.$axios.get(url).then((response) => {
                    let vLesson = response.data;

                    if (vLesson !== null) {
                        that.showTransition = true;

                        setTimeout(() => {
                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();
                        }, 400);

                        Utils.$emit('setLessonFinish', that.lessonId);
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            getOptionHeight: function() {
                return 'calc((100vw - 60px)/2.0)';
            },
            getImageHeight:function() {
                return 'calc(100vh - ' + this.getNavCount()+'px - ' + this.screenWidth + 'px)';
            },
            goInsidePages:function(id){
                this.$router.push({name: 'pageView', query: {url: "https://xiaohuasheng.cn/mtesthome_"+ id +"/come_1"}});
            },
            guideWordsAfterClick:function(){
                let that = this;

                if (that.noShowGuideWordsAfter === 1) {
                    return;
                }

                that.$axios.get("/bigCat/saveGuidePrompt/key5").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideWordsAfter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            submitClick:function(){
                let that = this;

                let vIsLast = that.listCourseQuestion.length === that.questionIndex;

                if (!vIsLast) {
                    that.questionIndex++;
                    that.showRightAnswerArray = [];

                    let objQuestion = that.getQuestionItem();

                    if (objQuestion == null) {
                        return "";
                    }

                    that.audioUrl = that.$qiNiuDomainBase + objQuestion.audio;

                    var t;
                    clearTimeout(t);
                    t = setTimeout(function () {
                        that.playAudio();
                    }, 400);
                } else {
                    that.getEnglishProgramStar();
                }

                this.scrollToTop();

                $(".option_img_item").each(function (idex, item) {
                    $(item).show();
                });
            },
            closeTransition:function() {
                this.showTransition = false;
            },
            backCourseMain:function() {
                let that = this;
                that.questionIndex = 1;
                this.$router.go(-1);
            },
            nextClick() {
                let that = this;
                that.showTransition = false;
                that.questionIndex = 1;

                if (that.pageType === 1) {
                    this.$router.replace({name: "PLyric", query: {lessonId: this.lessonId}});
                } else {
                    let url = "englishProgram/getWeeklyReviewQuestion/" + that.lessonId;

                    that.$axios.get(url).then((response) => {
                        that.listCourseQuestion = response.data;

                        if (!that.isEmpty(that.listCourseQuestion)) {
                            that.playCurrentAudio();
                        }
                    }).catch(function (error) {
                        window.console.log(error)
                    });
                }
            },
            playCurrentAudio() {
                let that = this;
                let vCourseQuestion = that.listCourseQuestion[that.questionIndex - 1];
                that.audioUrl = that.$qiNiuDomainBase + vCourseQuestion.audio;

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    that.playAudio();
                }, 100);
            },
            playErrorAudio() {
                const errorAudio = document.getElementById('error_audio');
                errorAudio.play();
            },
            playSuccessAudio() {
                const successAudioPlay = document.getElementById('success_audio');
                successAudioPlay.play();
            },
            optionClick:function(objQuestionOption, index){
                let that = this;
                let isRightAnswer = that.getCount(objQuestionOption.isRightAnswer);
                that.guideWordsAfterClick();

                // 0不是正确答案/1是正确答案
                if (isRightAnswer === 0) {
                    that.playErrorAudio();
                    $("#error_" + index).show();
                    setTimeout(function () {
                        $("#error_" + index).hide();
                    }, 500);
                    return;
                }

                that.playSuccessAudio();
                $("#success_" + index).show();
                setTimeout(function () {
                    $("#success_" + index).hide();
                    that.submitClick();
                }, 1000);
            },
            getStateHeight:function(){
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount:function() {
                return this.getStateHeight() + 44;
            },
            getQuestionItem:function () {
                let that = this;
                return that.listCourseQuestion[that.questionIndex - 1]
            },
            getQuestionImg:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return "";
                }

                return this.$qiNiuDomainBase + objQuestion.picture;
            },
            getOptionArray:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return [];
                }

                return objQuestion.optionArray;
            },
            getItemWord:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();


                if (objQuestion == null) {
                    return "";
                }

                return objQuestion.word;
            },
            scrollToTop:function () {
                window.scrollTo(0, 0);
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            playAudio() {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + vError);
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let vType = this.getCount(that.$route.query.type);
            let url = "englishProgram/getWeeklyReviewQuestion/" + vLessonId;

            if (vType === 1) {
                url = "englishProgram/getLastLessonReview/" + vLessonId;
            }

            that.$axios.get(url).then((response) => {
                if (!that.isEmpty(response.data)) {
                    that.hideStatusAndStopAudio();
                    that.lessonId = vLessonId;
                    that.pageType = vType;

                    setTimeout(() => {
                        transformView();

                        that.listCourseQuestion = response.data;
                        let vCourseQuestion = that.listCourseQuestion[0];

                        if (!that.isEmpty(vCourseQuestion.backgroundColor)) {
                            that.backgroundColor = vCourseQuestion.backgroundColor;
                        }

                        that.optionImgScrollBG = "rgba(0,0,0,0.5)";
                        that.audioUrl = that.$qiNiuDomainBase + vCourseQuestion.audio;

                        var t;
                        clearTimeout(t);
                        t = setTimeout(function () {
                            that.playAudio();
                        }, 100);
                    }, 200);
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.scrollToTop();
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatus(1);
            next();
        },
    }
</script>

<style scoped>

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .question_main {
        position:absolute;
        width:100vmax;
        height:100vmin;
    }

    .left_content {
        width: calc(100vmax - 100vmin - 10px);
        height: 100vmin;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
    }

    .left_content .page_num {
        position: absolute;
        width: calc(100vmax - 100vmin - 10px);
        top: 13px;
        color: white;
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }
    .left_content .page_num span {
        font-size: 28px;
        font-weight: bold;
    }

    .structure_content {
        position: absolute;
        width: 100vmin;
        height: 100vmin;
        z-index: 997;
        display: inline-block;
        right: 10px;
    }

    .question_main .question_img_content {
        display: flex;
        width: calc(100vmax - 100vmin);
        justify-content: center;
        align-items: center;
    }
    audio {
        display: none;
    }

    .audio_play {
        position: relative;
        display: flex;
        z-index:600;
        text-align: center;
    }
    .question_img_content .audio_play img {
        width: 40px;
        height: 40px;
    }
    .question_img_content .audio_content {
        position: relative;
        z-index:599;
        width: 50vmin;
        height: 22.5vmin;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FFB339;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        margin-left: -20px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 25px;
        color: white;
        font-family: Arial;
    }
    .option_img {
        position: relative;
    }
    .option_img .option_img_scroll {
        width: 100vmin;
        overflow-y: hidden;
        overflow-x: hidden;
        margin-top: 20px;
        position: fixed;
        bottom: 0;
    }
    .option_img .option_img_scroll::-webkit-scrollbar {
        display: none;
    }
    .option_img .option_img_scroll .option_img_item {
        display: inline-flex;
        position: relative;
        width: calc((100% - 60px)/2.0);
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 20px;
    }
    .option_img .option_img_scroll .option_img_item .lazy_img {
        width: 100%;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        background-color: white;
    }
    .option_img .option_img_scroll .option_img_item .error {
        position: absolute;
        z-index: 9999;
        background-color: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
        border-radius: 9px;
        -webkit-border-radius: 9px;
        -moz-border-radius: 9px;
        display: none;
    }
    .option_img .option_img_scroll .option_img_item .error img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .option_img_item .success {
        position: absolute;
        z-index: 9999;
        background-color: rgba(47,205,0,0.8);
        width: 100%;
        height: 100%;
        border-radius: 9px;
        -webkit-border-radius: 9px;
        -moz-border-radius: 9px;
        display: none;
    }
    .option_img_item .success img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .navigation .right {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform:translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #d4d4d4;
        font-size: 16px;
        font-weight: bold;
        color: #999999;
        text-align: center;
        line-height: 30px;
    }
    .navigation .right_post {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform:translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #FFAA00;
        font-size: 16px;
        font-weight: bold;
        color: white;
        text-align: center;
        line-height: 30px;
    }
    .bubbleContainer2{
        position: absolute;
        top: -33px;
        left: calc((100% - 105px)/2);
        padding-bottom: 12px;
        z-index: 999;
    }
    .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer2 .img {
        position: absolute;
        bottom: 0;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img img {
        width: 12px;
    }
    .option_content {
        position: relative;
        right: 0;
    }

    .question_main .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .question_main .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .question_main .transition .content2 {
        text-align: center;
    }

    .question_main .transition .content3 {
        text-align: center;
    }
    .question_main .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .question_main .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .question_main .transition .content .text span {
        display: block;
        text-align: center;
    }
    .question_main .transition .content .text .success_tip {
        font-size: 24px;
    }
    .question_main .transition .content .star {
        height: 35px;
    }
    .question_main .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .question_main .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .question_main .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

</style>
